$(window).on('load',function(){
    if($('.membership-registration').length > 0){
        $('.membership-registration form').css('display','block');
        $('.verfication').on('change',function(){
            //get the file name
            var fileName = $(this).val();
            //replace the "Choose a file" label
            $(this).next('.custom-file-label').html(fileName);
        });
        $('input[name="tx_membershipregistration_registration[registration][memberschip]"]').on('change',function(){
            if($(this).is(':checked') === true){
                $(this).closest('.form-group').find('.fam-mebers').fadeIn()
            }else{
                $(this).closest('.form-group').find('.fam-mebers').fadeOut()
            }
        });

        $('input[name="tx_membershipregistration_registration[registration][memberschip]"]').on('change', function() {
            if($(this).val() === 'reduced'){
                $(this).closest('form').find('.proof').fadeIn()
            }else {
                $(this).closest('form').find('.proof').fadeOut()
            }
            if($(this).val() === 'memberschipFam' || $(this).val() === 'sponsorFam'){
                $(this).closest('.form-group').find('.fam-mebers').fadeIn()
            }else if ($(this).val() !== 'memberschipFam' || $(this).val() !== 'sponsorFam'){
                $(this).closest('form').find('.fam-mebers').fadeOut()
            }
        });

        $('input[name="tx_membershipregistration_registration[registration][verification]"]').on('change', function() {
            //get the file name
            var fileName = $(this).val().replace('C:\\fakepath\\', " ");;
            //replace the "Choose a file" label
            $(this).next('.custom-file-label').html(fileName);
        });

        $('input[name="tx_membershipregistration_registration[registration][gifterMember]"]').on('change', function() {
            if($(this).val() === 'yes'){
                $(this).closest('form').find('.gifter-member-no input').attr('disabled',true);
                $(this).closest('form').find('.gifter-member-no').fadeOut()
                $(this).closest('form').find('.gifter-member-yes input').attr('disabled',false);
                $(this).closest('form').find('.gifter-member-yes').fadeIn()
            }else {
                $(this).closest('form').find('.gifter-member-yes input').attr('disabled',true);
                $(this).closest('form').find('.gifter-member-yes').fadeOut()
                $(this).closest('form').find('.gifter-member-no input').attr('disabled',false);
                $(this).closest('form').find('.gifter-member-no').fadeIn()
            }
        });

        $('.membership-registration form').each(function () {
            $(this).formValidation({
                framework: 'bootstrap',
                fields: {
                    'tx_membershipregistration_registration[registration][memberschip]': {
                        validators: {
                            notEmpty: {
                                message: 'Bitte wählen Sie eine der möglichen Karten aus'
                            }
                        }
                    },
                    'tx_membershipregistration_registration[registration][newsletter]': {
                        validators: {
                            notEmpty: {
                                message: 'Bitte wählen Sie eine der Antworten aus.'
                            }
                        }
                    },
                },
                plugins: {
                    autoFocus: new FormValidation.plugins.AutoFocus(),
                    submitButton: new FormValidation.plugins.SubmitButton(),
                    defaultSubmit: new FormValidation.plugins.DefaultSubmit(),
                    declarative: new FormValidation.plugins.Declarative({
                        html5Input: true,
                    }),
                    trigger: new FormValidation.plugins.Trigger({
                        event: 'change keyup input',
                        threshold: 3,
                        delay: 1,
                    }),
                    excluded: new FormValidation.plugins.Excluded({}),
                    message: new FormValidation.plugins.Message({
                        clazz: 'error',
                        container:function (field,element) {
                            return $(element).parent().get(0);
                        }
                    }),
                },
            });
            $(this).data('formValidation').on('core.element.validated',function (event) {
                if(event.valid === true){
                    $(event.element).parent().toggleClass('invalid')
                }else{
                    $(event.element).parent().toggleClass('invalid')
                }
            });
        })

        $('.membership-registration form select').on('change',function(){
           if($(this).val() === ''){
               $(this).addClass('color-placeholder')
           } else {
               $(this).removeClass('color-placeholder')
           }
        });

        $('select.paymentToggle').on('change', function() {
            $(this).closest('.payment').find('.info').hide()
           if ($(this).val() === 'sepa') {
                $(this).closest('.payment').find('.sepa').fadeIn()
           }
           if ($(this).val() === 'ueberweisung') {
               $(this).closest('.payment').find('.transfer').fadeIn()
           }
        });

    }
});
